var React = require('react');

function CreditCardIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"credit-card","d":"M0 2.5h20v3.3H0zm0 15h20v-10H0v10zm8.8-4h1.6v1.6H8.8v-1.6zm-7.6 0h6.3v1.6H1.2v-1.6z"}));
}

CreditCardIcon.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = CreditCardIcon;

CreditCardIcon.default = CreditCardIcon;
